import React from 'react';
import {
    MedicineBoxOutlined,
    TeamOutlined
} from '@ant-design/icons';

/* ===== Shared styles (đồng bộ ServiceColumnCell) ===== */
const sectionLabelStyle = {
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    color: '#595959',
    marginRight: 4
};

const staffNameStyle = {
    fontWeight: 600,
    color: '#111',
    fontSize: 14
};

const labelIconStyle = {
    fontSize: 14,
    color: '#8c8c8c',
    marginRight: 6
};

/* ===== Utils ===== */
const uniq = (arr) => Array.from(new Set(arr));

const extractStaff = (arr, userKey) =>
    uniq(
        (arr || [])
            .map(v => v?.[userKey]?.full_name)
            .filter(Boolean)
    );

const extractRole = (arr, userKey, fallback) =>
    arr?.[0]?.[userKey]?.user_role?.name || fallback;

/* ===== Component ===== */
const MedicalStaffBlock = ({
    doctors = [],
    doctorRoleGroups = null,
    assistants = [],
    showEmpty = true,
    bordered = true,
}) => {
    const doctorNames = extractStaff(doctors, 'doctor');
    const normalizedDoctorGroups = Array.isArray(doctorRoleGroups)
        ? doctorRoleGroups.filter(group => group?.people?.length)
        : (doctorNames.length ? [{ key: 'legacy', label: extractRole(doctors, 'doctor', 'BÁC SĨ'), people: doctorNames.map(name => ({ name })) }] : []);
    const assistantNames = extractStaff(assistants, 'assistant');

    const assistantRole = extractRole(assistants, 'assistant', 'PHỤ TÁ');

    if (!normalizedDoctorGroups.length && !assistantNames.length) {
        return showEmpty
            ? <span style={{ color: '#bfbfbf' }}>—</span>
            : null;
    }

    return (
        <div
            style={{
                lineHeight: 1.6,
                padding: bordered ? '8px 0 8px 8px' : 0,
                borderLeft: bordered ? '3px solid #e6f4ff' : 'none',
                marginLeft: bordered ? '-8px' : 0
            }}
        >
            {/* ===== BÁC SĨ ===== */}
            {normalizedDoctorGroups.map(group => (
                <div key={group.key}>
                    <MedicineBoxOutlined style={labelIconStyle} />
                    <span style={sectionLabelStyle}>{group.label}:</span>
                    <span style={staffNameStyle}>{group.people.map(person => person.name).join(', ')}</span>
                </div>
            ))}

            {/* ===== PHỤ TÁ ===== */}
            {assistantNames.length > 0 && (
                <div>
                    <TeamOutlined style={labelIconStyle} />
                    <span style={sectionLabelStyle}>
                        {assistantRole}:
                    </span>
                    <span style={staffNameStyle}>
                        {assistantNames.join(', ')}
                    </span>
                </div>
            )}
        </div>
    );
};

export default MedicalStaffBlock;
